module.exports = __webpack_public_path__ + "assets/img/not_data_tips-5385bf2a.png";